import { Container, FormGroup, Skeleton } from "@mui/material"
import { Store } from "../../apis/ersys-data/api"
import { Control } from "react-hook-form"
import FormInputTextArea from "../forms/FormInputTextArea"
import FormInputCheckbox from "../forms/FormInputCheckbox"

interface StoreTermsTabProps {
    control: Control<Store, any>
    showSkeleton: () => boolean,
    formSpacing: number
}

const StoreTermsTab: React.FC<StoreTermsTabProps> = ({ control, showSkeleton, formSpacing }) => {

    const renderSkeleton = () => {
        return (
            <FormGroup sx={{width: "100%"}}>
                <Skeleton variant='rectangular' width={800} height={200} sx={{ margin: 2 }} />
            </FormGroup>
        )
    }

    return (
        <Container>
            {showSkeleton() ? renderSkeleton() :
                <FormGroup>
                    <FormInputCheckbox 
                        control={control}
                        label="Enable TOS"
                        name="showTOS"
                        spacing={formSpacing}                        
                    />                
                    <FormInputTextArea 
                        rows={12}
                        whitespace="pre-wrap"
                        control={control}
                        label="Terms Of Service"
                        name="termsOfService"
                        spacing={formSpacing}
                    />
                </FormGroup>}
                </Container>
    )
}

export default StoreTermsTab